import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportComponent } from './report/report.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgZorroModule } from 'src/app/ng-zorro.module';
import { ClarificationQueryModule } from '../clarification-query/clarification-query.module';



@NgModule({
  declarations: [
    ReportComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgZorroModule,
    ClarificationQueryModule
  ]
})
export class ReportModule { }
